import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

import { MojoUrlProvider } from '../../mojo/services/mojo-url-provider';
import { MyActivityWidgetItem } from '../models/my-activity-widget-item';

@Injectable()
export class MyActivitiesDataHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlProvider: MojoUrlProvider
  ) { }

  getMyActivities(): Observable<Array<MyActivityWidgetItem>> {
    const url = this.urlProvider.myActivitiesApi();

    return this.http
      .get<MyActivityWidgetItem[]>(url).pipe(
        map(activities => activities || [])
      );
  }
}
